import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    autoDismiss: { type: Boolean, default: false },
    autoDismissTimeout: { type: Number, default: 5000 },
    transitionDuration: { type: Number, default: 300 }
  }

  connect() {
    // 1. add transition classes & start hidden
    this.element.classList.add(
      "tw-transition",
      "tw-ease-out",
      "tw-duration-[VAR]",
      "tw-opacity-0"
    )
    // inject the actual duration for both enter & leave
    this.setDurationClasses()

    // 2. trigger fade-in on next frame
    requestAnimationFrame(() => {
      this.element.classList.remove("tw-opacity-0")
    })

    // 3. optional auto-dismiss
    if (this.autoDismissValue) {
      this.autoDismissTimer = setTimeout(
        () => this.dismiss(),
        this.autoDismissTimeoutValue
      )
    }
  }

  disconnect() {
    // clean up timer if element is removed before timeout
    if (this.autoDismissTimer) clearTimeout(this.autoDismissTimer)
  }

  dismiss() {
    // fade-out
    this.element.classList.add("tw-opacity-0")
    // remove from DOM after transition
    setTimeout(() => {
      this.element.remove()
    }, this.transitionDurationValue)
  }

  setDurationClasses() {
    // replace the placeholder in the duration class
    const durClass = `tw-duration-${this.transitionDurationValue}`
    this.element.classList.forEach(cls => {
      if (cls.startsWith("tw-duration-[")) {
        this.element.classList.replace(cls, durClass)
      }
    })
  }
}
